import axios from "axios";
import {config} from ".";
import {SERVER_URL} from "../../../constants/ClientConfig";
import {trackClickEvent, trackPageLoad} from "../../../utils/railsAnalytics";
import { generateId } from '../../../utils/trainUtils';
import { GET_IRCTC_BOOKING_ID_URL, STORAGE_CONSTANTS } from "../../../constants/TrainConstants";
import { resetTimer } from "../../../utils/timer";
import {
  setItemBySession,
  itemType
} from 'MMT-UI/storages/client/sessionStorage';

export const getMmtIdFromQuery = () => {
  try {
    const params = new URLSearchParams(window.location.search);
    return params.get('mmtId') || params.get('encryptedMmtId') || null;
  } catch (error) {
    return null;
  }
};

export const persistMmtId = (mmtId) => {
  if (!mmtId) return;
  try {
    localStorage.setItem("currentMMTBookingId", JSON.stringify(mmtId));
  } catch (error) {
    console.error("Error while persisting mmtId");
  }
};

export const getMmtId = () => {
  const fromUrl = getMmtIdFromQuery();
  if (fromUrl) {
    return fromUrl;
  }
  try {
    return JSON.parse(localStorage.getItem("currentMMTBookingId"));
  } catch (error) {
    return null;
  }
};

/**
 * Calls getBookingId/v2 to resume/extend IRCTC booking window (parity with RNW NeedHelp).
 * On success, resets the client 10-min timer.
 */
export const resumeBookingSession = async (mmtId) => {
  const bookingId = mmtId || getMmtId();
  if (!bookingId) {
    return { success: false };
  }

  persistMmtId(bookingId);

  try {
    const traceId = generateId();
    const res = await axios.get(GET_IRCTC_BOOKING_ID_URL, {
      params: {
        mmtId: bookingId,
      },
      headers: {
        "X-Trace-Id": traceId,
      },
    });

    const { irctcBookingId = '', wsUserLogin = '', errorDetails } = res.data || {};
    if (errorDetails || !irctcBookingId) {
      return { success: false, errorDetails };
    }

    if (wsUserLogin) {
      setItemBySession(
        STORAGE_CONSTANTS.VERIFIED_USER_ID,
        wsUserLogin,
        { isPiiData: true, shouldStringifyJson: true },
        itemType.ES
      );
    }

    resetTimer(bookingId);
    return {
      success: true,
      irctcBookingId,
      wsUserLogin,
    };
  } catch (error) {
    console.error("Error while resuming booking session", error);
    return {
      success: false,
      error,
    };
  }
};

export const submit = async (pageId, data) => {
  const traceId = generateId();
  const url = constructUrl(pageId, "POST");
  const headers = {"X-Trace-Id": traceId};
  const response = await axios.post(url, {
    ...data,
    mmtId: getMmtId(),
    pageId,
  },{ headers });
  if (response.status === 200) {
    return {
      status: config.STATUS.D,
      message: 'Thank you for your feedback. Your feedback helps us to keep improving our product.'
    }
  } else {
    return {
      status: config.STATUS.F,
      message: 'Error'
    }
  }
};

export const constructUrl = (pageId, type) => {
  if (type === "GET") {
    switch (pageId) {
      case config.PAGE_ID.CANCEL_BOOKING:
      case config.PAGE_ID.WRONG_CREDENTIALS:
      case config.PAGE_ID.OTHER_ISSUES:
        return {
          url: `${SERVER_URL}/getContent`,
          payload: {
            pageId
          }
        };
      case config.PAGE_ID.BOOKING_DETAILS:
        return {
          url: `${SERVER_URL}/getBookingDetails`,
          payload: {
            bookingId: getMmtId(),
          }
        };
      default:
        return "";
    }
  } else {
    switch (pageId) {
      case config.PAGE_ID.CANCEL_BOOKING:
      case config.PAGE_ID.OTHER_ISSUES:
        return `${SERVER_URL}/postContent`;
      default:
        return '';
    }
  }
};

export const isTextQuestion = (questionId) => {
  return config.TEXT_AREA_QUESTIONS.includes(questionId);
}

export const trimTrailingSpaces = (value) => {
  return value.replace(/ +$/, "");
};

export const trackPage = (pageName) => {
  trackPageLoad(pageName);
}

export const trackClick = (pageName, id) => {
  trackClickEvent(pageName, id);
}
